import React from 'react'
import { Link } from 'react-router-dom'
import {MapPin, Clock, Mail, Phone, Shield} from 'lucide-react'
import { lumi } from '../lib/lumi'

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#1e3a8a] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo e Descrição */}
          <div>
            <img 
              src="https://static.lumi.new/material/fd/fd208cdb7c6b89103dc6a3e704c4cafe.png" 
              alt="REFUGE IN CHRIST MINISTRY" 
              className="h-16 w-auto mb-4 bg-white p-2 rounded"
            />
            <p className="text-sm text-gray-300">
              Um lugar de refúgio, acolhimento e proteção espiritual. Venha fortalecer sua fé conosco.
            </p>
          </div>

          {/* Links Rápidos */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Links Rápidos</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/sobre" className="hover:text-[#6b8f71] transition-colors">Sobre Nós</Link></li>
              <li><Link to="/oracao" className="hover:text-[#6b8f71] transition-colors">Pedir Oração</Link></li>
              <li><Link to="/palavra-deus" className="hover:text-[#6b8f71] transition-colors">Sermões</Link></li>
              <li><Link to="/eventos" className="hover:text-[#6b8f71] transition-colors">Eventos</Link></li>
              <li><Link to="/escola-biblica" className="hover:text-[#6b8f71] transition-colors">Escola Bíblica</Link></li>
            </ul>
          </div>

          {/* Horários */}
          <div>
            <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
              <Clock size={20} />
              Horários de Culto
            </h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>Domingo - 0h e 00h</li>
              <li>Quarta - 00h00</li>
              <li>Sexta - 00h</li>
              <li>Escola Bíblica - Sábado 00h</li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contato</h3>
            <ul className="space-y-3 text-sm text-gray-300">
              <li className="flex items-start gap-2">
                <MapPin size={18} className="flex-shrink-0 mt-0.5" />
                <span>13906 Fifth St<br />Dade city FL 33525  United States</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={18} />
                <span>+1 (352) 424-8391</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={18} />
                <span>contato@refugioemcristo.com.br</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-white/20 text-center text-sm text-gray-300">
          <p>&copy; {new Date().getFullYear()} REFUGE IN CHRIST MINISTRY. Todos os direitos reservados.</p>
          
          {/* Link Admin - Apenas para usuários ADMIN */}
          {lumi.auth.user?.userRole === 'ADMIN' && (
            <div className="mt-4">
              <Link 
                to="/admin" 
                className="inline-flex items-center gap-2 text-xs text-gray-400 hover:text-[#6b8f71] transition-colors"
              >
                <Shield size={14} />
                Painel Administrativo
              </Link>
            </div>
          )}
        </div>
      </div>
    </footer>
  )
}

export default Footer
